"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitRequestTimes = exports.BSSRetry = exports.NETWORK_ERR_STATUS = void 0;
var MAX_REQUEST_TIMES = 5;
exports.NETWORK_ERR_STATUS = 0;
function BSSRetry(status, url) {
    var bssUploadAPIRegex = /api\/upload\/v(1|2)\/blobs/;
    if (status < 200 || status > 400) {
        return bssUploadAPIRegex.test(url) && status !== 403 && status !== 401;
    }
    return false;
}
exports.BSSRetry = BSSRetry;
var LimitRequestTimes = /** @class */ (function () {
    function LimitRequestTimes() {
        this.requestCount = 0;
        this.requestURLContainer = '';
        this.appendIndex = '';
    }
    LimitRequestTimes.prototype.limit5Times = function (url, index) {
        if (this.requestURLContainer === url && this.appendIndex === index) {
            this.requestCount += 1;
        }
        else {
            this.requestCount = 0;
            this.requestURLContainer = url;
            this.appendIndex = index;
        }
        return this.requestCount < MAX_REQUEST_TIMES;
    };
    return LimitRequestTimes;
}());
exports.limitRequestTimes = new LimitRequestTimes();
//# sourceMappingURL=BSSRetry.js.map